import {PhoneNumber} from "antd-phone-input";

export const phoneToString = (value: PhoneNumber): string => {
    if (!value) {
        return '';
    }
    return `${value.countryCode}${value.areaCode}${value.phoneNumber}`;
}